
import { defineComponent, ref, reactive, computed, onMounted, nextTick, watch, toRefs, onUnmounted } from 'vue'
import {
  SearchOutlined,
  PlusCircleOutlined,
  InfoCircleFilled,
  RollbackOutlined,
  SyncOutlined,
  DoubleLeftOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined
} from '@ant-design/icons-vue'
import Table from '@/components/hotTable.vue'
import Select from '@/components/hotSelect.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'
import { hotApi } from '@/api/index'
import ws from '../websocket/index'
import * as echarts from 'echarts'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import { getMarketKeyById } from '@/utils/stock'
import globalsets from '@/utils/globalsets'
import { maskStockName, maskStockCode } from '@/utils/maskUtils'

const __default__ = defineComponent({
  components: {
    SearchOutlined,
    PlusCircleOutlined,
    InfoCircleFilled,
    RollbackOutlined,
    SyncOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    Table,
    Select,
    Nodata,
    ArrowUpOutlined,
    ArrowDownOutlined
  },
  setup() {
    const getNumber1 = globalsets.getNumber1
    const state: any = reactive({
      columns: [],
      tableData: [],
      columns1: [],
      tableData1: [],
      upTime: '',
      hotTimer: null,
      hotCur: {} as any,
      selectedRowId: 1,
      tags: [],
      shouldAutoSelect: false, // 添加标志来跟踪是否需要自动选中
      tabLoading: false,
      hasChartData1: false, // echarts1 是否有数据
      hasChartData2: false,
      hotListLoading: false, // getHotList 的全局 loading
      showExplain: false,
      getContainer: () => document.querySelector('.hot-wrapper')
    })
    const loadHotDetail = ref(false)
    const activeKey = ref('1')
    const route = useRoute()
    const theme = route.query.theme || 'light'

    // mcnMode=1 启用掩码处理（需要在 rightColumns 之前定义）
    const mcnMode = ref(route.query.mcnMode === '1')
    const maskName = (name: string) => maskStockName(name, mcnMode.value)
    const maskedDisplayName = computed(() => maskStockName(state.hotCur?.name, mcnMode.value))
    const maskedDisplayCode = computed(() => maskStockCode(state.hotCur?.symbol, mcnMode.value))

    // 存储图表实例
    let chartInstance1: any = null
    let chartInstance2: any = null
    let currentChartData1: any = null
    let currentChartData2: any = null
    state.columns = [
      {
        title: '排名',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
        slots: { customRender: 'rankColor' } // 添加自定义渲染
      },
      {
        title: '板块名称',
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        width: 150,
        slots: { customRender: 'bkName' }
      },
      {
        title: '最新',
        dataIndex: 'LastPrice',
        key: 'LastPrice',
        align: 'left',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '涨幅',
        dataIndex: 'increase',
        key: 'increase',
        align: 'left',
        slots: { customRender: 'increase' }
      },
      {
        title: '热度',
        dataIndex: 'hotValue',
        key: 'hotValue',
        align: 'right',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '领涨股',
        dataIndex: 'riseFirstGrpName',
        key: 'riseFirstGrpName',
        align: 'left',
        slots: { customRender: 'riseFirstGrpName' }
      },
      {
        title: '领涨涨幅',
        dataIndex: 'riseFirstGrpRise',
        key: 'riseFirstGrpRise',
        align: 'left',
        slots: { customRender: 'riseFirstGrpRise' }
      },
      {
        title: '涨跌家数',
        dataIndex: 'riseAFall',
        key: 'riseAFall',
        align: 'left',
        slots: { customRender: 'riseAFall' }
      },
      {
        title: '主力净流入',
        dataIndex: 'mainCleanForceIn',
        key: 'mainCleanForceIn',
        align: 'right',
        slots: { customRender: 'mainPeopleCountColor' }
      }
    ]
    state.columns1 = [
      {
        title: '排名',
        dataIndex: 'rank',
        key: 'rank',
        align: 'center',
        slots: { customRender: 'rankColor' } // 添加自定义渲染
      },
      {
        title: '较昨日',
        dataIndex: 'changeRank',
        key: 'changeRank',
        align: 'center',
        slots: { customRender: 'changeRank' }
      },
      {
        title: '股票名称',
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        slots: { customRender: 'stockName' }
      },
      {
        title: '最新',
        dataIndex: 'LastPrice',
        key: 'LastPrice',

        align: 'left',
        slots: { customRender: 'peopleCountColorUpdate' }
      },
      {
        title: '涨幅',
        dataIndex: 'increase',
        key: 'increase',
        align: 'left',
        slots: { customRender: 'increase' }
      },
      {
        title: '热度',
        dataIndex: 'hot',
        key: 'hot',
        align: 'right',
        slots: { customRender: 'peopleStockCount' }
      }

    ]
    const removeDuplicateObj = (arr: any) => {
      // 缓存用于记录
      const newArr: any = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (newArr.find((c: any) => c.symbol === t.symbol && c.market === t.market)) {
          continue
        }
        newArr.push(t)
      }
      // 记录结果就是过滤后的结果
      return newArr
    }
    function subon(list: any, isInit: boolean = false) {
      nextTick(() => {
        // 列表去重
        const data = removeDuplicateObj(list)
        let stockList: Array<object> = []
        let keyList: Array<string> = []
        data.forEach((item: any) => {
          let obj = {
            symbol: item.symbol,
            market: item.market,
          } as object
          let str = item.symbol + item.market
          stockList.push(obj)
          keyList.push(str)
        })
        ws.websocket.safeSubscribeList(keyList, stockList)
      })
    }
    onMounted(() => {
      state.hotListLoading = true
      // state.isInit = true

      // 隐藏 loading
      const rootLoading = document.getElementById('rootLoading')
      if (rootLoading) {
        rootLoading.style.display = 'none'
      }

      stopTimer()
      getHotList(true)
      startTimer()
      addResizeListener()
    })
    onUnmounted(() => {
      stopTimer()
      removeResizeListener()
      // 清理图表实例
      if (chartInstance1) {
        chartInstance1.dispose()
        chartInstance1 = null
      }
      if (chartInstance2) {
        chartInstance2.dispose()
        chartInstance2 = null
      }
    })
    function checkStock(obj: any, isInit: boolean = false) {
      state.tags = isInit ? [] : obj
      // let index: any = ''
      let changeRank: any = ''
      let tableDataItem: any = {}
      //如果不在tab1,先切回tab1
      state.tableData.forEach((item: any) => {
        if (item.market == obj.MarketCode && item.symbol == obj.Code) {
          // index = item.rank
          changeRank = item.changeRank
          tableDataItem = { ...item }
        }
      })
      // index: index,
      state.hotCur = { market: obj.MarketCode, symbol: obj.Code, name: obj.Name, changeRank: changeRank, ...tableDataItem }
      state.selectedRowId = tableDataItem?.rank || ''

      // 滚动到选中的行
      nextTick(() => {
        tableDataItem?.rank && scrollToSelectedRow(tableDataItem?.rank)
      })

      if (activeKey.value !== '1') {

        // // 取消订阅
        // suboff(state.tableData)
        // state.tableData = [] // 切换前先清空表格数据
        // activeKey.value = '1'
        // stopTimer()
        // getHotList()
        // startTimer()

        nextTick(() => {
          tabClick('1', false)
        })
        console.log('checkStocktabClick', state.hotCur)

      } else {
        console.log('checkStockgetHotDetail', state.hotCur)
        // 直接获取详情，而不是重新获取列表，避免重复调用
        getHotDetail(state.hotCur.market, state.hotCur.symbol)
      }


    }

    // 滚动到选中的行
    function scrollToSelectedRow(rank: number) {

      // 延迟执行，确保DOM已更新
      setTimeout(() => {
        // 查找表格容器
        const tableContainer = document.querySelector('.ant-table-body')
        if (!tableContainer) {
          return
        }

        // 查找目标行
        const targetRow = tableContainer.querySelector(`tr[data-row-key="${rank}"]`)
        let foundRow: any = null
        if (!targetRow) {
          // 尝试通过其他方式查找行
          const allRows = tableContainer.querySelectorAll('tr')
          for (let i = 0; i < allRows.length; i++) {
            const row = allRows[i]

            const rowKey = row.getAttribute('data-row-key')
            if (rowKey && parseInt(rowKey) === rank) {
              foundRow = row
              break
            }
          }
          if (!foundRow) {
            return
          }
        }

        const targetRowElement = targetRow || foundRow

        // 计算滚动位置
        const containerRect = tableContainer.getBoundingClientRect()
        const rowRect = targetRowElement.getBoundingClientRect()
        const scrollTop = tableContainer.scrollTop

        // 计算目标行相对于容器的位置
        const rowTop = rowRect.top - containerRect.top + scrollTop
        const rowHeight = rowRect.height
        const containerHeight = containerRect.height

        // 计算滚动位置，让目标行在容器中央
        const targetScrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2)

        // 平滑滚动到目标位置
        tableContainer.scrollTo({
          top: Math.max(0, targetScrollTop),
          behavior: 'smooth'
        })
      }, 100) // 延迟100ms执行
    }

    // 将market id转换为对应的键名
    function convertMarketIdToKey(market: string): string {
      if (!market) {
        return market
      }
      const convertedKey = getMarketKeyById(market)
      return convertedKey || market
    }

    // 根据symbol和market在tableData中查找对应的数据并触发checkStock
    function selectStockBySymbol(symbol: string, market: string, isInit: boolean = false) {

      // 在tableData中查找匹配的股票
      const foundStock = state.tableData.find((item: any) => {
        return item.symbol === symbol && item.market === market
      })

      if (foundStock) {
        // 构造checkStock需要的参数格式
        const stockObj = {
          Code: foundStock.symbol,
          MarketCode: foundStock.market,
          Name: foundStock.name,
          changeRank: foundStock.changeRank
        }
        // 触发checkStock方法
        checkStock(stockObj, isInit)
      }
    }
    function getEchart(dom: any, data: any, chartType: 'chart1' | 'chart2' = 'chart1') {
      // 根据data判断是否有数据

      if (!dom) {
        return
      }
      // 如果图表实例已存在，先销毁
      if (chartType === 'chart1' && chartInstance1) {
        chartInstance1.dispose()
      } else if (chartType === 'chart2' && chartInstance2) {
        chartInstance2.dispose()
      }

      const chart = echarts.init(dom)

      // 存储图表实例和数据
      if (chartType === 'chart1') {
        // 对数据进行时间排序
        const sortedData = data.sort((a: any, b: any) => {
          // 将时间字符串转换为可比较的格式
          const timeA = a[0].split(':').map(Number)
          const timeB = b[0].split(':').map(Number)

          // 比较小时和分钟
          if (timeA[0] !== timeB[0]) {
            return timeA[0] - timeB[0]
          }
          return timeA[1] - timeB[1]
        })
        chartInstance1 = chart
        currentChartData1 = sortedData
      } else {
        chartInstance2 = chart
        currentChartData2 = data
      }

      // 配置 X 轴 - 使用时间轴
      let maxTimeValue = 0
      if (chartType === 'chart1') {
        // 获取当天起始时间
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        // 获取第二天00:00（即24:00）
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        maxTimeValue = tomorrow.getTime()
      }

      const xAxisConfig: any = chartType === 'chart1' ? {
        type: 'time',
        min: new Date().setHours(0, 0, 0, 0),  // 当天 00:00
        max: maxTimeValue,  // 第二天 00:00 (显示为24:00)
        splitInterval: 2 * 60 * 60 * 1000,  // 每2小时一个刻度 (2小时 * 60分钟 * 60秒 * 1000毫秒)
        axisLabel: {
          formatter: (function (maxTime) {
            return function (value: any) {
              const date = new Date(value)
              const hours = date.getHours()

              // 判断是否接近maxTime（第二天00:00），如果是则显示24:00
              const timeValue = date.getTime()
              if (Math.abs(timeValue - maxTime) < 1000) {  // 1秒内的误差都认为是24:00
                return '24:00'
              }

              // 普通时间显示 HH:00
              return `${hours.toString().padStart(2, '0')}:00`
            }
          })(maxTimeValue),
          interval: 0,  // 显示所有刻度标签
          showMinLabel: true,
          showMaxLabel: true
        },
        axisTick: {
          alignWithLabel: true
        },
        boundaryGap: false
      } : {
        type: 'category',
        boundaryGap: false
      }

      // 处理数据格式 - chart1 需要转换为时间戳格式
      const seriesData = chartType === 'chart1' ? (() => {
        // 使用固定的当天日期，避免日期不一致
        const baseDate = new Date()
        baseDate.setHours(0, 0, 0, 0)

        return data.map((item: any) => {
          // item 格式: [时间字符串, rank, hot]
          const timeStr = item[0]  // "09:30" 格式
          const [hours, minutes] = timeStr.split(':')
          const date = new Date(baseDate)
          date.setHours(parseInt(hours), parseInt(minutes), 0, 0)
          return [date.getTime(), item[1], item[2]]
        })
      })() : data

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',  // 显示 X 和 Y 轴的交叉指示线
            lineStyle: {
              type: 'dashed',  // 设置虚线
              color: '#B2B2B2',  // 虚线颜色
              width: 1  // 虚线宽度
            }
          },
          formatter: function (params: any) {
            let time
            if (chartType === 'chart1') {
              // 时间轴模式，从时间戳格式化
              const date = new Date(params[0].data[0])
              const hours = date.getHours().toString().padStart(2, '0')
              const minutes = date.getMinutes().toString().padStart(2, '0')
              time = `${hours}:${minutes}`
            } else {
              time = params[0].data[0]
            }
            const rank = params[0].data[1]
            const hot = params[0].data[2]
            const timeLabel = chartType === 'chart2' ? '日期' : '时间'

            return `
                  <div style='color:#666;'>${timeLabel}：${time}<div>
                  <div style='color:#666;'>排名：${rank}<div>
                  <div style='color:#666;'>热度：${getNumber1(hot * 1000)}<div>
              `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: xAxisConfig,
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: seriesData,
            type: 'line',
            symbol: data.length === 1 ? 'rect' : 'none',  // 只有一条数据时显示矩形标记，多条数据时隐藏标记
            smooth: false  // 保持折线平滑度
          }
        ]
      }
      chart.setOption(option)

    }


    // 取消订阅
    function suboff(data: any) {
      console.log('suboff', data)
      const _data = data
      if (!_data.length) return
      let stockList: Array<object> = []
      let keyList: Array<string> = []
      data.forEach((item: any) => {
        let obj = {
          symbol: item.symbol,
          market: item.market,
        } as object
        let str = item.symbol + item.market
        stockList.push(obj)
        keyList.push(str)
      })
      ws.websocket.safeUnsubscribeList(keyList, stockList)
    }
    ws.websocket.on('onHQLIST', msg => {
      // console.log('onHQLIST事件触发，tableData长度:', state.tableData)
      // console.log('msg数据:', msg?.QuoteData?.DynaData)
      if (state.tableData && state.tableData.length) {
        state.tableData.forEach((item: any, index: number) => {
          msg?.QuoteData?.DynaData?.forEach(msgItem => {
            if (item.symbol !== msgItem.InstrumentID) return
            if (msgItem.LastPrice !== undefined) {
              item.LastPrice = msgItem.LastPrice
            }
            if (msgItem.UpdownRate !== undefined) {
              item.increase = msgItem.UpdownRate * 100
            }


            // 更新领涨股名称
            if (msgItem.LZCode && msgItem.LZName && item.riseFirstGrp) {

              item.riseFirstGrp.name = msgItem.LZName
            }

            // 更新领涨涨幅：计算公式 (lznewprice - lzyclose) / lzyclose
            if (msgItem.LZCode && msgItem.LZNewPrice !== undefined && msgItem.LZPreClose !== undefined && item.riseFirstGrp) {
              const lzNewPrice = parseFloat(msgItem.LZNewPrice)
              const lzPreClose = parseFloat(msgItem.LZPreClose)
              item.riseFirstGrp.pxChangeRate = (lzNewPrice - lzPreClose) / lzPreClose
            }

            // 更新涨跌家数：szjs / xdjs
            if (msgItem.LZCode && msgItem.Z !== undefined && msgItem.D !== undefined && item.riseCount !== undefined && item.fallCount !== undefined) {
              const szjs = msgItem.Z || 0
              const xdjs = msgItem.D || 0
              item.riseCount = szjs
              item.fallCount = xdjs
            }

          })
        })
      }
      // state.tableData.slice(0, 0)
    })
    //请求概念榜/行业榜
    function customRow(record: any) {
      return {
        onClick: () => {
          state.selectedRowId = record.rank
          state.hotCur = { market: record.market, symbol: record.symbol, index: record.rank, name: record.name, changeRank: record.changeRank }
          state.tags = [] // 点击时清空Select的input值

          // 滚动到选中的行
          nextTick(() => {
            scrollToSelectedRow(record.rank)
          })

          getHotDetail(state.hotCur.market, state.hotCur.symbol)
        },
        onDblclick: () => {
          // 双击事件处理逻辑
          state.tags = [] // 双击时清空Select的input值

          // 优化1: 参数验证
          if (!record || !record.symbol || !record.market) {
            return
          }

          window.open(`gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params><code>${record.symbol}</code><market_letter>${record.market}</market_letter><technique_type>0</technique_type><technique_name></technique_name><element_InfoTab><SubTabName></SubTabName></element_InfoTab><QUOTE_TAB_pt><SubTabName></SubTabName></QUOTE_TAB_pt><level2_orderchart_type>-1</level2_orderchart_type><StyleName>FSZS</StyleName><TabName>分时图</TabName><flag_container_style>R</flag_container_style></params>`)

        }
      }
    }

    //请求概念榜/行业榜
    function customRow2(record: any) {
      return {
        onDblclick: () => {
          // 双击事件处理逻辑

          // 优化1: 参数验证
          if (!record || !record.symbol || !record.market) {
            return
          }

          window.open(`gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params><code>${record.symbol}</code><market_letter>${record.market}</market_letter><technique_type>0</technique_type><technique_name></technique_name><element_InfoTab><SubTabName></SubTabName></element_InfoTab><QUOTE_TAB_pt><SubTabName></SubTabName></QUOTE_TAB_pt><level2_orderchart_type>-1</level2_orderchart_type><StyleName>FSZS</StyleName><TabName>分时图</TabName><flag_container_style>R</flag_container_style></params>`)

        }
      }
    }
    function setRowClassName(record: any) {
      return record.rank === state.selectedRowId ? 'selected-row' : '';
    }
    function getHotPList(key: any) {
      const appVersion = route.query.appVersion as string
      const headers = appVersion ? { appVersion } : {}

      hotApi.hotPList({
        plateType: key == '2' ? 'XBHS.GN' : 'XBHS.HY',
        limit: 100
      }, headers).then((res: any) => {

        // suboff(state.tableData) //tabClick 已经取消了
        state.upTime = res.currentTime ? window.moment(res.currentTime).format('HH:mm') : '—'
        if (res.data) {
          suboff(res.data)

          nextTick(() => {
            state.tableData = res.data.map((item: any, index: any) => {
              item.index = index
              return item
            })
            subon(state.tableData)
          })


        } else {
          state.tableData = []
        }
      }).finally(() => {
        // 强制重新渲染table组件
      })
    }
    function getHotList(isInit: boolean = false) {


      hotApi.hotList({ pageNo: 1, pageSize: 100, token: route.query.token }).then((res: any) => {
        // suboff(state.tableData) //tabClick 已经取消了
        if (res.data) {
          if (res.data.length) {
            suboff(res.data)
          }
          // 如果是初始化，检查路由参数是否在前100来为 shouldAutoSelect 赋值
          const symbol = state.hotCur?.symbol || route.query.symbol as string
          const market = state.hotCur?.market || route.query.market as string

          if (symbol) {
            // 将market id转换为对应的键名
            const marketKey = convertMarketIdToKey(market)

            // 检查路由参数的股票是否在前100
            const foundInTop100 = res.data.find((item: any) => {
              return item.symbol === symbol && item.market === marketKey
            })

            // 根据是否在前100为 shouldAutoSelect 赋值
            if (foundInTop100) {
              state.shouldAutoSelect = true
            } else {
              state.shouldAutoSelect = false
            }
          }

          //判断选中的代码是否在前100，如不在前一百,更新为第1条，如在前100，保留原来代码；进行详情请求
          // state.hotCur = state.hotCur?.index === '' ? state.hotCur : findHotCur(res.data, state.hotCur)

          // 如果是初始化且有路由参数需要自动选中，则不在这里调用 getHotDetail
          // 让 selectStockBySymbol -> checkStock -> getHotList 的流程来调用


          state.tableData = res.data
          subon(state.tableData, true)

          // 数据加载完成后，检查是否需要根据路由参数自动选中股票 market
          if (state.shouldAutoSelect) {
            const symbol = state.hotCur?.symbol || route.query.symbol as string
            const marketKey = state.hotCur?.market || convertMarketIdToKey(route.query.market as string)
            console.log('checkStockgetHotList666')

            if (symbol && marketKey) {
              // 先重置标志，避免重复选中
              state.shouldAutoSelect = false
              nextTick(() => {
                selectStockBySymbol(symbol, marketKey, isInit)
              })
            }
          } else {
            let obj
            if (isInit && route.query.symbol === 'CLSDATA') {
              let cur = findHotCur(res.data, state.hotCur)
              obj = { MarketCode: cur.market, Code: cur.symbol, Name: cur.name, ...cur }
              console.log('obj', obj)
            } else {
              obj = { MarketCode: state.hotCur?.market || convertMarketIdToKey(route.query.market as string), Code: state.hotCur?.symbol || route.query.symbol, Name: state.hotCur?.name || route.query.symbolName }
            }
            checkStock(obj, isInit)
          }

        }
      }).finally(() => {
        state.hotListLoading = false
      })
    }
    function startTimer() {
      state.hotTimer = setInterval(() => {
        getHotList()
        // 3 * 60 * 1000
      }, 3 * 60 * 1000)
    }
    function stopTimer() {
      if (state.hotTimer) {
        clearInterval(state.hotTimer)
        state.hotTimer = null
      }
    }
    function findHotCur(list: any, obj: any) {
      let temp: any
      if (state.hotCur) {
        list.forEach((item: any) => {
          if (item.market == obj.market && item.symbol == obj.symbol) {
            temp = { market: item.market, symbol: item.symbol, index: item.rank, name: item.name, changeRank: item.changeRank }
          }
        })
      }
      if (temp) {
        return temp
      } else {
        state.selectedRowId = 1
        return { market: list[0].market, symbol: list[0].symbol, index: 1, name: list[0].name, changeRank: list[0].changeRank }
      }
    }

    function formatTimestampToDate(timestamp: number): string {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始需 +1
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    function formatData(data: any, type: string) {
      const resData: [string, number, number][] = []; // 明确 resData 的类型

      // 如果是 date 类型，需要过滤数据：T-1日的前1个月，不包含T-1日当天
      let filteredData = data


      filteredData.map((item: any) => {
        item.time = type == 'time' ? window.moment(item.time).format('HH:mm') : formatTimestampToDate(item.time)
        resData.push([item.time, item.rank, item.hot])
      })


      return resData
    }
    // 防抖函数
    function debounce(func: Function, wait: number) {
      let timeout: any
      return function executedFunction(this: any) {
        const args = arguments
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    }

    // 重新渲染图表的函数
    function resizeCharts() {
      if (chartInstance1 && currentChartData1) {
        const dom1 = document.getElementById('echarts1')
        if (dom1) {
          getEchart(dom1, currentChartData1, 'chart1')
        }
      }
      if (chartInstance2 && currentChartData2) {
        const dom2 = document.getElementById('echarts2')
        if (dom2) {
          getEchart(dom2, currentChartData2, 'chart2')
        }
      }
    }

    // 创建防抖的resize函数
    const debouncedResizeCharts = debounce(resizeCharts, 300)

    // 添加resize事件监听器
    function addResizeListener() {
      window.addEventListener('resize', debouncedResizeCharts)
    }

    // 移除resize事件监听器
    function removeResizeListener() {
      window.removeEventListener('resize', debouncedResizeCharts)
    }

    function getHotDetail(market: any, symbol: any) {

      loadHotDetail.value = true
      hotApi.hotMin({ market, symbol }).then((res: any) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          state.hasChartData1 = true

          // 先根据 time 进行排序
          const sortedList = res.data.list.sort((a: any, b: any) => {
            return a.time - b.time
          })

          // 从排序后的数据中计算排名变动
          const latestRank = sortedList[sortedList.length - 1].rank // 最新排名
          const prevRank = sortedList.length >= 2 ? sortedList[sortedList.length - 2].rank : latestRank // 上一条排名

          // 设置最新排名和变动值
          if (state.hotCur) {
            state.hotCur.index = latestRank // 即时排名
            state.hotCur.rankChange = prevRank - latestRank //实时变动的排名： 上一条排名 - 最新排名
          }

          nextTick(() => {
            const dom1 = document.getElementById('echarts1')
            if (dom1) {
              getEchart(dom1, formatData(sortedList, 'time'), 'chart1')
            }
          })
        } else {
          state.hasChartData1 = false
          if (chartInstance1) {
            chartInstance1.dispose()
            chartInstance1 = null
            currentChartData1 = null
          }
        }
        state.upTime = res.data?.updateTime ? window.moment(res.data.updateTime).format('HH:mm') : '—'
      }).finally(() => {
        loadHotDetail.value = false
      })
      hotApi.hotHis({ market, symbol }).then((res: any) => {
        if (res.data && res.data.list && res.data.list.length > 0) {

          const latestRank = res.data.list[res.data.list.length - 1].rank // 最新排名
          const prevRank = res.data.list.length >= 2 ? res.data.list[res.data.list.length - 2].rank : latestRank // 上一条排名


          // 设置最新排名和变动值
          if (state.hotCur) {
            state.hotCur.hisRankChange = prevRank - latestRank //实时变动的排名： 上一条排名 - 最新排名
          }


          // 计算 T-1 日（昨天）
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const tMinus1 = new Date(today)
          tMinus1.setDate(tMinus1.getDate() - 1) // T-1日

          // 计算 T-1 日的前1个月（往前推30天）
          const oneMonthAgo = new Date(tMinus1)
          oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1) // 前1个月
          oneMonthAgo.setHours(0, 0, 0, 0)

          // T-1 日的结束时间（不包含当天，所以是 T-1 日的 00:00）
          const tMinus1Start = new Date(tMinus1)
          tMinus1Start.setHours(0, 0, 0, 0)

          // 过滤数据：时间在 [oneMonthAgo, tMinus1Start) 范围内
          const filteredData = res.data.list.filter((item: any) => {
            const itemTime = item.time // 时间戳
            return itemTime >= oneMonthAgo.getTime() && itemTime <= tMinus1Start.getTime()
          })

          let hotList = filteredData



          state.hasChartData2 = Boolean(hotList.length > 0)
          nextTick(() => {
            const dom2 = document.getElementById('echarts2')
            if (dom2) {
              getEchart(dom2, formatData(hotList, 'date'), 'chart2')
            }
          })
        } else {
          state.hasChartData2 = false
          if (chartInstance2) {
            chartInstance2.dispose()
            chartInstance2 = null
            currentChartData2 = null
          }
        }
      })
    }
    function tabClick(key: any, isInit: boolean = true) {
      activeKey.value = key
      state.tabLoading = true
      // suboff(state.tableData)
      state.tableData = [] // 切换前先清空表格数据

      // 延迟数据加载，让tab切换动画先完成
      nextTick(() => {
        setTimeout(() => {
          if (key == 1) {
            stopTimer()
            getHotList(isInit) // tab切换时传入true，保持输入框为空
            startTimer()
          } else {
            state.tags = []
            stopTimer()
            getHotPList(key)
          }
          state.tabLoading = false
        }, 300) // 延迟150ms
      })
    }

    return {
      ...toRefs(state),
      activeKey,
      customRow,
      customRow2,
      tabClick,
      setRowClassName,
      checkStock,
      selectStockBySymbol,
      scrollToSelectedRow,
      theme,
      maskName,
      maskedDisplayName,
      maskedDisplayCode
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b5318da2": (_ctx.theme === "dark" ? "#121a2f" : "#eceff3"),
  "421d899c": (_ctx.theme === "dark" ? "#252a34" : "#DBDFE6"),
  "6517b1e4": (_ctx.theme === "dark" ? "#1d2230" : "#fff"),
  "6ddbf40e": (_ctx.theme === "dark" ? "#aaaaaa" : "#7D7D7D"),
  "00746f9d": (_ctx.theme === "dark" ? "#fff" : "#636363"),
  "45d7e220": (_ctx.theme === "dark" ? "#fff" : "#000"),
  "169ad203": (_ctx.theme === "dark" ? "#333" : "#f2f2f2")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__